module.exports = __webpack_public_path__ + "img/type_02.679e5073.png";